import { render, staticRenderFns } from "./DownloadInformer.vue?vue&type=template&id=415b1ad7&functional=true"
import script from "./DownloadInformer.vue?vue&type=script&lang=js"
export * from "./DownloadInformer.vue?vue&type=script&lang=js"
import style0 from "./DownloadInformer.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports